import SiteText from './SiteText.jsx';
import Logo from './assets/logo.png'

const Footer = () => {
    return <div className="bg-secondary">
        <div className="flex justify-center pt-8">
            <img src={Logo} alt="Elite Power Wash Logo"/>
        </div>
        <div className="flex max-lg:flex-col justify-center items-center mt-8 text-xl text-white">
            <div className="w-full sm:w-1/3 lg:h-32 lg:pl-96 text-center lg:text-right max-lg:mb-8 lg:flex lg:flex-col lg:justify-center">
                <p>{SiteText.Global.Contact.Address.Street1}</p>
                <p>{SiteText.Global.Contact.Address.City}, {SiteText.Global.Contact.Address.State}</p>
                <p>{SiteText.Global.Contact.Address.PostalCode}</p>
            </div>
            <div className="max-lg:border-y-4 max-lg:p-8 lg:border-x-4 border-tertiary lg:h-32 w-1/2 lg:w-1/6 lg:mx-16 flex flex-col items-center justify-center">
                <p>{SiteText.Global.Contact.Email}</p>
                <p>{SiteText.Global.Contact.Phone}</p>
            </div>
            <div className="w-1/3 h-32 max-lg:m-8 lg:pr-96 text-center lg:text-left lg:flex lg:flex-col lg:justify-center">
                <p>{SiteText.Footer.WorkHours[0]}</p>
                <p>{SiteText.Footer.WorkHours[1]}</p>
            </div>
        </div>
    </div>
};

export default Footer;